module.exports = __webpack_public_path__ + "static/phase-2.d6ac9eaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/figures/phase-2.svg
// module id = 797
// module chunks = 75823452005409